// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as CatalogVariantLossReportModal from "./CatalogVariantLossReportModal.res.js";
import * as CatalogVariantDeliveryReportModal from "./CatalogVariantDeliveryReportModal.res.js";
function keyExtractor(row) {
  return row.shopId;
}
let Row = {
  keyExtractor: keyExtractor
};
let columns = [{
  key: "shopname",
  name: I18n.t("Shop/Warehouse"),
  layout: {
    minWidth: {
      NAME: "px",
      VAL: 150
    },
    margin: "normal"
  },
  render: param => JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: param.data.shopName
    }),
    spaceY: "xxsmall"
  })
}, {
  key: "stock-quantity",
  name: "Stock",
  layout: {
    width: {
      NAME: "fr",
      VAL: 0
    }
  },
  render: param => {
    let match = param.data;
    return JsxRuntime.jsx(ProductStockTableCell.make, {
      value: match.formattedQuantity,
      state: match.state
    });
  }
}];
let styles = {
  multishopStockText: {
    "font-kVVagm": "font-x1uij5j5",
    $$css: "wino-gc:src/modules/Catalog/CatalogVariantStockTableCard.res.js:67"
  }
};
let initialModalsState = {
  loss: false,
  delivery: false
};
function CatalogVariantStockTableCard(props) {
  let shopsVariantStock = props.shopsVariantStock;
  let cku = props.cku;
  let match = React.useState(() => initialModalsState);
  let setReportingModalsOpened = match[1];
  let reportingModalsOpened = match[0];
  let match$1 = Auth.useScope();
  let multishop;
  multishop = match$1.TAG === "Organisation" ? match$1.activeShop === undefined : false;
  let shopsStockDiffering = multishop && CatalogVariant.MultiShops.arrayKeepUniqueBy(shopsVariantStock, (a, b) => {
    if (a.capacityUnit === b.capacityUnit) {
      return a.capacityPrecision === b.capacityPrecision;
    } else {
      return false;
    }
  }).length > 1;
  let makeMultishopStock = React.useCallback((capacityUnit, capacityPrecision) => {
    let totalStock = Stdlib_Array.reduce(shopsVariantStock, 0, (acc, stock) => acc + stock.rawQuantity | 0);
    return CatalogVariant.StockQuantity.format(totalStock, capacityPrecision, capacityUnit);
  }, [shopsVariantStock]);
  let onRequestClose = React.useCallback(() => setReportingModalsOpened(param => initialModalsState), []);
  let match$2 = shopsVariantStock[0];
  let tmp;
  if (multishop && !(shopsStockDiffering || match$2 === undefined)) {
    let newrecord = {
      ...{
        className: "font-x1uij5j5",
        "data-style-src": "wino-gc:src/modules/Catalog/CatalogVariantStockTableCard.res.js:67"
      }
    };
    tmp = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx("span", (newrecord.children = makeMultishopStock(match$2.capacityUnit, match$2.capacityPrecision), newrecord)),
      spaceBottom: "medium"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Card.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Box.make, {
          children: [tmp, JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Button.make, {
              label: I18n.t("Loss"),
              tone: "danger",
              onPress: () => setReportingModalsOpened(param => ({
                loss: true,
                delivery: false
              }))
            }), JsxRuntime.jsx(Button.make, {
              label: I18n.t("Delivery"),
              tone: "success",
              onPress: () => setReportingModalsOpened(param => ({
                loss: false,
                delivery: true
              }))
            })],
            space: "small"
          })],
          spaceX: "large"
        }), JsxRuntime.jsx(TableView.make, {
          data: {
            TAG: "Done",
            _0: {
              TAG: "Ok",
              _0: shopsVariantStock
            }
          },
          columns: columns,
          keyExtractor: keyExtractor
        })],
        space: "small"
      }),
      title: multishop ? "Stocks" : "Stock",
      variation: "table"
    }), JsxRuntime.jsx(CatalogVariantLossReportModal.make, {
      cku: cku,
      opened: reportingModalsOpened.loss,
      shopsVariantStock: shopsVariantStock,
      onRequestClose: onRequestClose
    }), JsxRuntime.jsx(CatalogVariantDeliveryReportModal.make, {
      cku: cku,
      opened: reportingModalsOpened.delivery,
      shopsVariantStock: shopsVariantStock,
      onRequestClose: onRequestClose
    })]
  });
}
let make = React.memo(CatalogVariantStockTableCard);
let Config;
export { Config, Row, columns, styles, initialModalsState, make };
/* columns Not a pure module */